import { HTTP_CODE } from '@/constants'
import Errors from '@/views/Errors'

export default [
  {
    path: '*',
    meta: {
      title: 'errors.error',
      public: true
    },
    name: 'error.notFound',
    component: Errors,
    props: { type: HTTP_CODE.NOT_FOUND }
  },
  {
    path: '/403',
    name: 'error.accessDenied',
    component: Errors,
    props: { type: HTTP_CODE.ACCESS_DENIED }
  },
  {
    path: '/500',
    meta: {
      public: true
    },
    name: 'error.serverError',
    component: Errors,
    props: { type: HTTP_CODE.SERVER_ERROR }
  }
]
